<script setup lang="ts">
import type { HouseDetails } from '~/types/house/types'

const props = withDefaults(
  defineProps<{
    house: HouseDetails
    matterportVideoUrl?: string
  }>(),
  {
    matterportVideoUrl: '',
  },
)
const emits = defineEmits<{ 'open-modal-virtual-visit': [] }>()

const { trackEvent } = useTracking()

const openModalVirtualVisit = () => {
  emits('open-modal-virtual-visit')

  trackEvent({
    category: 'Product page',
    event: 'virtual_visit_requested',
    house_id: Number(props.house.id),
  })
}
</script>

<template>
  <div class="md:border-grey-200 pb-10 md:mb-9 md:border-b">
    <h2 class="m-0 mb-1 text-2xl lg:mb-2">
      {{ $t('house.virtualVisit.title') }}
    </h2>
    <p class="mb-6">
      {{ $t('house.virtualVisit.text') }}
    </p>

    <video autoplay class="mb-6 w-full" controls loop muted playsinline>
      <source :src="matterportVideoUrl" type="video/mp4" />
    </video>

    <BaseButton
      class="w-full !text-md !font-bold lg:w-[275px]"
      color="secondary"
      variant="outline"
      @click="openModalVirtualVisit"
    >
      {{ $t('house.virtualVisit.getContacted') }}
    </BaseButton>
  </div>
</template>
